import React, { useEffect, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Switch, Route, useHistory } from "react-router-dom"

import Header from "../../components/header"
import Sidebar from "../../components/sidebar"
import GuidesContainer from "./Guides"
import EditGuideContainer from "./Guides/Edit"
import DestinationSettingsContainer from "./Settings"
import PartnersContainer from "./Partners"
import ExamplesContainer from "./Examples"
import ErrorContainer from "../Error/404"
import MissingDestinationContainer from "../Error/destination"
import { fetchDestinationById } from "../../actions/destinations"
import { fetchTeams } from "../../actions/team"
import type { RootState } from "../../store"

const HomeContainer: React.FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const destinations = useSelector((state: RootState) => state.destinations.destinations)
  const selectedDestinationId = useSelector((state: RootState) => state.destinations.selectedDestinationId)

  const selectedDestination = useMemo(() => {
    if (!selectedDestinationId) return undefined
    return destinations.find(d => d.id === selectedDestinationId)
  }, [destinations, selectedDestinationId])

  // Fetch teams
  useEffect(() => {
    dispatch(fetchTeams())
  }, [dispatch])

  // Fetch destination
  useEffect(() => {
    if (selectedDestinationId) {
      try {
        dispatch(fetchDestinationById(selectedDestinationId))
      } catch {
        history.push("/handbooks")
      }
    } else {
      history.push("/handbooks")
    }
  }, [dispatch, history, selectedDestinationId])

  return (
    <>
      <Header />
      <div className="tw-has-header tw-has-sidebar">
        <div className="xl:tw-container tw-mx-auto tw-w-full tw-px-4 sm:tw-px-12">
          <Switch>
            <Route exact path="/handbook/examples" component={ExamplesContainer} />
            <Route exact path="/handbook/partners" component={PartnersContainer} />
            {!destinations?.length && <Route path="*" component={MissingDestinationContainer} />}
            {/* Visible only if user have destinations */}
            <Route exact path="/handbook/guides" component={GuidesContainer} />
            <Route exact path="/handbook/guides/:id" component={EditGuideContainer} />
            <Route exact path="/handbook/settings" component={DestinationSettingsContainer} />
            {/* Error page */}
            <Route path="*" component={ErrorContainer} />
          </Switch>
        </div>
      </div>
      <Sidebar type="handbook" selectedProject={selectedDestination} />
    </>
  )
}

export default HomeContainer
